module.exports = __webpack_public_path__ + "static/js-ecuador-map-4d8830cdf5f970155007692d022f2743.svg";